import { ValidatorMessagePipe } from './../common/pipes/validator-message.pipe';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthModule } from './auth/auth.module';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgPipesModule } from 'ngx-pipes';
import { AppHttpInterceptor } from '../core/interceptors/http.interceptor';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

// primeng
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { PipesModule } from '../common/pipes/pipes.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// slidshow
// import { SwiperModule } from 'ngx-swiper-wrapper';

import { PasswordEyesDirective } from '../common/directives/password-eyes.directive';
import { FormSubmitDirective } from './../common/directives/form-submit.directive';
import { ValidatorMessageDirective } from './../common/directives/validator-message.directive';
import { MatNumberOnlyDirective } from './../common/directives/mat-number-only.directive';

import { InitModule } from './init/init.module';
import { BaseService } from '../core';
import { FileUploadModule } from './file-upload/file-upload.module';
import { TPipe } from '../common/pipes/t.pipe';
// import { NgScrollbarModule } from 'ngx-scrollbar';
import { NumericDirective } from '../common/directives/numeric.directive';
// import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ClipboardModule } from 'ngx-clipboard';
import { provideNgxMask, NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';

const maskConfig = {
  validation: false,
};
// const maskModule = NgxMaskModule.forRoot(maskConfig);

const SHARED_DIRECTIVES = [
  PasswordEyesDirective,

  ValidatorMessageDirective,
  FormSubmitDirective,
  NumericDirective,
  MatNumberOnlyDirective,
];

const SHARED_MODULES = [
  InitModule,
  AuthModule,
  FileUploadModule,
  FormsModule,
  CommonModule,
  ReactiveFormsModule,

  HttpClientModule,
  AngularSvgIconModule,
  NgPipesModule,
  PipesModule,

  FontAwesomeModule,
  // NgScrollbarModule,

  // MatButtonModule,
  // MatMenuModule,
  // MatTabsModule,
  // MatFormFieldModule
  // MatChipsModule,
  MatInputModule,
  MatRadioModule,
  // MatProgressSpinnerModule,
  MatCheckboxModule,
  // MatCardModule,
  // MatSidenavModule,
  // MatGridListModule,
  // MatListModule,
  MatSelectModule,
  MatDialogModule,
  // MatToolbarModule,
  MatIconModule,
  // MatTooltipModule,
  // MatTableModule,
  // MatPaginatorModule,
  // MatSnackBarModule,
  MatSlideToggleModule,
  // MatDividerModule,
  // MatSliderModule,
  MatDatepickerModule,
  MatNativeDateModule,
  // FontAwesomeModule,
  // NgxPaginationModule,
  // NgxJsonViewerModule,
  MatAutocompleteModule,
  MatFormFieldModule,
  // primeng
  DropdownModule,
  // SwiperModule,
  DialogModule,
];

@NgModule({
  imports: [
    NgPipesModule,
    // I18NextModule.forRoot({
    //   errorHandlingStrategy: StrictErrorHandlingStrategy,
    // }),
    ClipboardModule,
    PipesModule,
    FileUploadModule,
    CommonModule,
    // maskModule,
    DropdownModule,
    // SwiperModule,
    DialogModule,
    NgxMaskDirective, // NgxMaskDirective 선언
    NgxMaskPipe, // NgxMaskPipe 선언
    InfiniteScrollDirective,
  ],
  providers: [
    // I18N_PROVIDERS,
    provideNgxMask(maskConfig), // 설정된 마스크 설정을 전역으로 적용
    BaseService,
    {
      provide: 'IHttpClient',
      useClass: HttpClient,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
  ],
  declarations: [...SHARED_DIRECTIVES],
  exports: [
    ...SHARED_MODULES,
    ...SHARED_DIRECTIVES,

    NgxMaskDirective, // 디렉티브 내보내기
    NgxMaskPipe, // 파이프 내보내기
    InfiniteScrollDirective,
    // maskModule.ngModule,
    ClipboardModule,
  ],
})
export class SharedModule {
  constructor() {}

  static forRoot(): any {
    return {
      ngModule: SharedModule,
      providers: [ValidatorMessagePipe, TPipe],
    };
  }
}
